import { dirFor, isLocale, type Locale } from '@/i18n';

/**
 * The locale is the first path segment, so a link, a bookmark and a shared URL
 * all carry the language with them.
 */
export function localePath(locale: Locale, path: string): string {
  const clean = path.startsWith('/') ? path : `/${path}`;
  return `/${locale}${clean === '/' ? '' : clean}`;
}

/** Same page, different language. Used by the language switcher. */
export function swapLocale(pathname: string, next: Locale): string {
  const segments = pathname.split('/').filter(Boolean);
  if (segments[0] && isLocale(segments[0])) segments[0] = next;
  else segments.unshift(next);
  return `/${segments.join('/')}`;
}

export function applyDocumentLocale(locale: Locale) {
  document.documentElement.lang = locale;
  document.documentElement.dir = dirFor(locale);
}
